import { DialogContent, DialogActions } from '@mui/material';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import { useState } from 'react';
import { ListData, CounterTag } from '@shared/ui/parts';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getTotalCards } from '@utils/helpers';
import { useGroups } from '@app/api/groups/useGroups';
//todo: добавить freeze reason
//todo: decline rate временно закомментирован, пока нет в api

export default function UnfreezeTeamDialog({ close, data }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const { handleSubmit } = useForm();

  const { unfreezeGroup } = useGroups();

  async function onSubmit() {
    setIsLoading(true);
    try {
      await unfreezeGroup({
        group_id: data.id,
        decline_rate: 1,
      });
      close();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <DialogContent>
        <div className="form">
          <p>{t('are_you_sure_unfreeze_team')}</p>
          <CounterTag data={data} iconType="members" />
          <ListData
            listData={[
              {
                label: t('team_cards'),
                value: getTotalCards(data),
              },
              {
                label: 'Freeze reason',
                value: '????',
              },
              // {
              //   label: t('current_decline_rate'),
              //   value: data.decline_rate + '%',
              // },
            ]}
          />
          {/* <FormGroup label={t('new_decline_rate_limit')}>
            <Controller
              control={control}
              name="decline_rate"
              render={({ field }) => (
                <div className="decline-rate-slider">
                  <p className="body-18r">{field.value}%</p>
                  <Slider
                    progress
                    min={3}
                    max={20}
                    value={field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                </div>
              )}
            />
          </FormGroup> */}
        </div>
        <Note
          marginTop
          type="warning"
          title={t('important')}
          content={t('unfreeze_team_note')}
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="unfreeze"
            onClick={handleSubmit(onSubmit)}
            loading={isLoading}
          >
            {t('yes_unfreeze')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
